import { render, staticRenderFns } from "./UploadLomLogo.vue?vue&type=template&id=2ab1a6d6"
import script from "./UploadLomLogo.vue?vue&type=script&lang=js"
export * from "./UploadLomLogo.vue?vue&type=script&lang=js"
import style0 from "./UploadLomLogo.vue?vue&type=style&index=0&id=2ab1a6d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports